export const EMOJIS = ["⚽","🏆","🎯","🦅","🔥","💪","🌟","👊","🎪","🏅","⚡","🎰"];

// Preise gehen an die TIPPGRUPPE als Ganzes (Sponsoring), nicht an Einzelpersonen.
export const GROUP_PRIZES = [
  { rank: 1, amount: 3000, label: "3.000 € Sponsoring", short: "3.000 €", icon: "🥇", tone: "gold" as const },
  { rank: 2, amount: 1500, label: "1.500 € Sponsoring", short: "1.500 €", icon: "🥈", tone: "silver" as const },
  { rank: 3, amount: 500,  label: "500 € Sponsoring",   short: "500 €",   icon: "🥉", tone: "bronze" as const },
];

// Einzel-Hauptpreis: Sieger:in der Gesamt-Einzelwertung (kommunikativ, nicht in DB getrackt).
export const SINGLE_PRIZE = {
  rank: 1,
  title: "Wellnessurlaub für 2",
  short: "2 Nächte Wellness",
  hotel: "Hotel Nesslerhof",
  location: "Großarl, Salzburger Land",
  nights: 2,
  persons: 2,
  url: "https://www.nesslerhof.at/",
  highlights: [
    "4★S Wellnesshotel im Großarltal",
    "Spa mit Saunen & neuem Onsen-Pool",
    "Naturbadeteich & beheizter Outdoorpool",
    "Kulinarium by ness — Frühstück & Dinner",
  ],
  icon: "🧖",
};

// Anmelde-Geschenk für jede:n neue:n Tipper:in (kommunikativ, nicht in DB getrackt).
export const SIGNUP_BONUS = {
  trikot: true,
  voucherEur: 50,
  minOrderEur: 1000,
  note: "Trikots solange der Vorrat reicht",
};

// Sponsor & single-prize awards are paid out once the WM final is finished.
// WM 2026 final: Sunday 19 July 2026, kickoff 21:00 CEST (MetLife Stadium,
// 15:00 ET). Regulation ~22:50 CEST; with AET + penalties ~23:30. Setting
// the deadline to 23:59 CEST on 19 July keeps the timer reading "until
// 19. Juli" right up to midnight while still expiring after worst-case FT.
export const PRIZE_DEADLINE = "2026-07-19T23:59:00+02:00";

// Production domain. Only used as a fallback when window.location.origin
// is unavailable (see share.ts appUrl()) — at runtime the live origin wins,
// so dev/staging links stay correct automatically.
export const APP_URL = "https://tippspiel.englputzeder.at";

export const LEVEL_NAMES = ["Rookie","Tipp-Anfänger","Tipp-Profi","Tipp-Meister","WM-Legende"];
export const LEVEL_THRESHOLDS = [0, 150, 500, 1000, 2000];

export function levelInfo(xp: number) {
  let level = 1;
  for (let i = LEVEL_THRESHOLDS.length - 1; i >= 0; i--) {
    if (xp >= LEVEL_THRESHOLDS[i]) { level = i + 1; break; }
  }
  const idx = level - 1;
  const nextThreshold = LEVEL_THRESHOLDS[idx + 1] ?? LEVEL_THRESHOLDS[idx];
  const prevThreshold = LEVEL_THRESHOLDS[idx];
  const progress = nextThreshold === prevThreshold
    ? 100
    : Math.min(100, Math.round(((xp - prevThreshold) / (nextThreshold - prevThreshold)) * 100));
  return { level, name: LEVEL_NAMES[idx], progress, nextThreshold, prevThreshold };
}

export const WM_TEAMS = [
  "Argentinien","Algerien","Australien","Belgien","Brasilien","Costa Rica","Curaçao","Deutschland",
  "Ecuador","Elfenbeinküste","England","Frankreich","Iran","Italien","Japan","Jordanien",
  "Kanada","Kolumbien","Kroatien","Marokko","Mexiko","Neuseeland","Niederlande","Nigeria",
  "Norwegen","Österreich","Paraguay","Polen","Portugal","Saudi-Arabien","Schottland","Schweiz",
  "Senegal","Serbien","Spanien","Südafrika","Südkorea","Tunesien","Türkei","Ukraine",
  "Uruguay","USA","Wales"
];

// 12 groups (A–L) for WM 2026
export const WM_GROUPS = ["A","B","C","D","E","F","G","H","I","J","K","L"];

export const PHASE_LABELS: Record<string, string> = {
  group: "Gruppenphase",
  r32: "Sechzehntelfinale",
  r16: "Achtelfinale",
  qf: "Viertelfinale",
  sf: "Halbfinale",
  third: "Spiel um Platz 3",
  final: "Finale",
};

export const BADGES: Record<string, { name: string; icon: string; desc: string }> = {
  scharfschuetze: { name: "Scharfschütze", icon: "🎯", desc: "Erstes exaktes Ergebnis getippt" },
  on_fire:        { name: "On Fire",       icon: "🔥", desc: "3 richtige Tipps in Folge" },
  koenig:         { name: "König des Tippens", icon: "👑", desc: "#1 im Ranking für 24h" },
  diamant:        { name: "Diamant-Tipp",  icon: "💎", desc: "Exaktes Ergebnis bei einem KO-Spiel" },
  goat:           { name: "GOAT",           icon: "🐐", desc: "Alle Spiele richtig getippt (Tendenz)" },
  blitz:          { name: "Blitz-Tipper",  icon: "⚡", desc: "Alle Tipps innerhalb 1h abgegeben" },
  prophet:        { name: "WM-Prophet",    icon: "🌍", desc: "WM-Gesamtsieger richtig getippt" },
};
